import React, { Fragment } from 'react'
import {
  POTENTIAL_CUSTOMERS_STATUS,
  POTENTIAL_CUSTOMERS_STATUS_COLOR,
  POTENTIAL_CUSTOMERS_JUMP
} from '@constant'
export default [
  {
    title: '用户名',
    dataIndex: ['user', 'nick']
  },
  {
    title: '关键行为',
    width: 134,
    render: ({ action, entity, entity_type, entity_id }) => (
      <Fragment>
        <span style={{ color: '#333' }}>{action}</span>
        {['Example', 'Package'].includes(entity_type) && (
          <a
            style={{
              display: 'block',
              width: 94,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            onClick={() => {
              window.open(
                POTENTIAL_CUSTOMERS_JUMP[entity_type] + entity_id,
                entity.title,
                `height=667, width=375, top=${(window.screen.height - 667) /
                  2},left=${(window.screen.width - 375) / 2}`
              )
            }}
          >
            {entity.title}
          </a>
        )}
      </Fragment>
    )
  },
  {
    title: '状态',
    render: ({ status }) => (
      <span style={{ color: POTENTIAL_CUSTOMERS_STATUS_COLOR[+status] }}>
        {POTENTIAL_CUSTOMERS_STATUS[+status]}
      </span>
    )
  },
  {
    title: '历史发送',
    dataIndex: 'push_count'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at'
  }
]
